import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './landing/landing.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { LtbUsageComponent } from './ltb-usage/ltb-usage.component';
import { SnAuthCallbackComponent, SnAuthGuard, SnAuthLoggedOutComponent } from '@insight/serenity-auth';
import { BulkUsageComponent } from './bulk-usage/bulk-usage.component';
// tslint:disable-next-line: max-line-length
import { DataFileConfigurationComponent } from './data-file-configutation/landing/data-file-configuration/data-file-configuration.component';
import { BackupConfigureComponent } from './client-config/backup-configure/backup-configure.component';
import { LandingModule } from './landing/landing.module';
import { ManualUsageLandingComponent } from './ltb-usage/manual-usage-landing/manual-usage-landing.component';
import { PersonaGuard } from './auth/authguards/persona-guard';
import { WrongPersonasComponent } from './auth/wrong-personas/wrong-personas.component';
import { SharedComponentsModule } from './shared/components/shared-components.module';

const routes: Routes = [
  { path: 'implicit/callback', component: SnAuthCallbackComponent },
  { path: 'landing', component: LandingComponent, canActivate: [SnAuthGuard, PersonaGuard]},
  { path: 'manual-usage', component: LtbUsageComponent, canActivate: [SnAuthGuard, PersonaGuard] },
  { path: 'bulk-usage', component: BulkUsageComponent, canActivate: [SnAuthGuard, PersonaGuard] },
  { path: 'manual-usage-landing', component: ManualUsageLandingComponent, canActivate: [SnAuthGuard, PersonaGuard] },
  { path: 'wrong-personas', component: WrongPersonasComponent},
  { path: 'logout', component: SnAuthLoggedOutComponent },
  { path: '', redirectTo: 'landing', pathMatch: 'full'},
  { path: '**', component: NotFoundComponent },
];

// Other Routes can be found in:
// - client-config-routing.module.ts

@NgModule({
  declarations: [
    LandingComponent,
    NotFoundComponent
  ],
  imports: [
    RouterModule.forRoot(routes, {enableTracing: true}),
    LandingModule,
    SharedComponentsModule
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
